import * as S from './styles'

const Line: React.FC<LineProps> = ({
  margin,
  size,
  orientation = 'horizontal'
}) => {
  return <S.Line margin={margin} size={size} orientation={orientation} />
}

export default Line
